import React, { useCallback } from 'react'
import { Drawer, Box } from '@mui/material'
import CampaignSidebarContent from './CampaignSidebarContent'

const CampaignSidebar = props => {
  const {
    isBelowMdScreen,
    sidebarOpen,
    setSidebarOpen,
    campaignDetails,
    activeTab,
    onTabChange,
    tabs = [],
    limits
  } = props

  const onClose = useCallback(() => {
    setSidebarOpen(false)
  }, [setSidebarOpen])

  return (
    <>
      {isBelowMdScreen
        ? (
        <Drawer
          open={sidebarOpen}
          onClose={onClose}
          className='bs-full'
          variant='persistent'
          ModalProps={{ disablePortal: true, keepMounted: true }}
          sx={{
            zIndex: sidebarOpen ? 11 : 10,
            position: 'absolute',
            height: '100%',
            '& .MuiDrawer-paper': {
              boxShadow: 'none',
              overflow: 'hidden',
              width: '260px',
              position: 'absolute',
              paddingTop: '12px'
            }
          }}
        >
          <CampaignSidebarContent
            campaignDetails={campaignDetails}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            limits={limits}
          />
        </Drawer>
          )
        : (
        <Box sx={{
          width: '260px',
          minWidth: '260px',
          flexShrink: 0,
          borderRight: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '12px'
        }}>
          <CampaignSidebarContent
            campaignDetails={campaignDetails}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            limits={limits}
          />
        </Box>
          )}
    </>
  )
}

export default CampaignSidebar
